<section>
    <!-- top  -->
    <section id="s-checkin" *ngIf="!isRefSPay">
        <div class="w-100 bgblue text-center py-3">
            <div class="container py-2">
                <div class="row">
                    <div class="col-12 text-center">
                        <img alt="Brand" src="assets/img/logo.svg" class="img img-fluid">
                    </div>

                </div>
            </div>
        </div>
    </section>
    <!-- end top -->
    <section>
        <div class="bgmain content pb-4">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mb-4 mt-5">
                        <div class="text-highlight text-center pt-3">Quý khách vui lòng trực tiếp đến Điểm giao dịch quét QRCode lấy STT </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4">
                        <div class="text-result text-center"><img src="assets/img/deliveri.png" alt="icon"
                                class="img-fluid"></div>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-lg-12 mb-4 mt-2">
                        <div class="text-lighter text-center pt-3">Khoảng cách từ vị trí hiện tại của bạn đến QRCode điểm giao dịch: {{metter | number:'1.0-0'}} mét</div>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
</section>